import i18n from 'i18next';
import translationsEnGB from './locales/translations.en_GB.json';
import translationsNbNO from './locales/translations.nb_NO.json';
export var locales = [
    {
        iso: 'en',
        i18next: 'en',
        backend: 'en',
        dayjs: 'en',
        translation: translationsEnGB,
        ui: 'EN',
    },
    {
        iso: 'no',
        i18next: 'no',
        backend: 'no',
        dayjs: 'nb',
        translation: translationsNbNO,
        ui: 'NO',
    },
    {
        iso: 'debug',
        i18next: 'cimode',
        backend: 'debug',
        dayjs: 'en',
        translation: translationsEnGB,
        ui: 'DEBUG',
    },
];
/*
  TODO: Commenting out the configuration for the floor planner, since it's clashing with portal-ui service
  The floor planner itself is not localised, so the translations need to be injected into floor-planner package somehow
  The configuration that's commented out below comes from previous `relokator-frontend` application
*/
export var localeByIso = function (iso) {
    return locales.find(function (l) { return l.iso === iso; }) || locales[0];
};
// const localeByI18Next = (i18next = 'en') => {
//   return locales.find((l) => l.i18next === i18next) || locales[0];
// };
// const resources = chain(locales)
//   .keyBy('iso')
//   .omit('cimode')
//   .mapValues((locale) => ({ translation: locale.translation }))
//   .value();
// i18n.use(initReactI18next).init({
//   resources,
//   lng: localeByIso(constants.PREFERRED_LANGUAGE_ISO).i18next,
//   fallbackLng: localeByIso(constants.FALLBACK_LANGUAGE_ISO).i18next,
//   debug: false,
//   interpolation: {
//     escapeValue: false, // not needed for react as it escapes by default
//     format: function (value, format, i18nextLanguage) {
//       if (isDayjs(value)) {
//         return value.locale(localeByI18Next(i18nextLanguage).dayjs).format(format);
//       }
//       return value;
//     },
//   },
// });
export default i18n;
//# sourceMappingURL=i18n.js.map